import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import {
  AssignedOperatorsResponse,
  AssignmentsGroupedByOrganisationResponse,
  AssignmentsOrganisationItem,
  MarketType,
} from 'src/pages/operators/assignments/overview/types';
import { DeepReadonly } from 'src/utils/deep-readonly';

type Options = {
  url: string;
};

// limited to 3 for testing purposes
export const DEFAULT_LIMIT_ASSIGNMENTS = 3;

export const mapAssignedOperatorsResponseToOrganisationAssignmentItems = (
  assignedOperators: DeepReadonly<AssignedOperatorsResponse[]>
): AssignmentsOrganisationItem[] => {
  return assignedOperators.map((assignedOperator) => ({
    organisationId: assignedOperator.tso.id,
    organisationName: assignedOperator.tso.name,
    status: assignedOperator.state,
    logoUrl: `${PRISMA_CONFIG.monolithUrl}${assignedOperator.tso.logoSmallUrl}`,
    marketAccess:
      assignedOperator.state !== 'APPROVED'
        ? undefined
        : ([
            ...(assignedOperator.primaryAccess ? ['PRIMARY'] : []),
            ...(assignedOperator.secondaryAccess ? ['SECONDARY'] : []),
          ] as MarketType),
  }));
};

export function useAssignmentsGroupedByOrganisation({ url }: Options) {
  const assignments = useAxios(
    (axios, signal) =>
      axios.request<AssignmentsGroupedByOrganisationResponse>({
        signal,
        url,
        method: 'GET',
      }),
    { neededOnPageLoad: false }
  );

  useEffect(() => {
    assignments.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return assignments;
}

export type AssignmentsGroupedByOrganisationRequest = ReturnType<
  typeof useAssignmentsGroupedByOrganisation
>;
